module.exports = __webpack_public_path__ + "static/media/KP.b34e4e58.svg";